// src/enums.ts
var BalanceTransactionType = {
  wallet_transfer: "wallet_transfer",
  balance_transfer: "balance_transfer",
  sale: "sale",
  manual_deposit: "manual_deposit",
  shift_settlement: "shift_settlement",
  expense: "expense",
  salary: "salary",
  supplier_payment: "supplier_payment",
  customer_payment: "customer_payment",
  customer_return: "customer_return"
};
var BalanceType = {
  cash: "cash",
  wallet: "wallet",
  visa: "visa"
};
var ExpenseCategoryOld = {
  electricity: "electricity",
  internet: "internet",
  rent: "rent",
  other: "other"
};
var CustomerStatus = {
  active: "active",
  suspended: "suspended",
  delete: "delete",
  removed: "removed"
};
var Platform = {
  ios: "ios",
  android: "android",
  web: "web"
};
var NotificationStatus = {
  granted: "granted",
  denied: "denied"
};
var EmployeeRole = {
  cashier: "cashier",
  admin: "admin",
  worker: "worker",
  employee: "employee"
};
var TransactionStatus = {
  normal: "normal",
  cancelled: "cancelled",
  edited: "edited"
};
var TransactionType = {
  purchase: "purchase",
  return: "return"
};
var MovementType = {
  SALE: "SALE",
  RESTOCK: "RESTOCK",
  ADJUSTMENT: "ADJUSTMENT",
  RETURN: "RETURN"
};
var StoragePlaceTransferStatus = {
  pending: "pending",
  completed: "completed",
  failed: "failed"
};
var LogStatus = {
  success: "success",
  failure: "failure"
};
var LogAction = {
  GET: "GET",
  POST: "POST"
};
var ImageEntity = {
  product: "product",
  section: "section",
  collection: "collection",
  announcement: "announcement",
  brand: "brand"
};
var announcementEntity = {
  product: "product",
  section: "section",
  collection: "collection"
};
var NotificationAudience = {
  all: "all",
  registered: "registered",
  unregistered: "unregistered",
  group: "group",
  customer: "customer"
};
var OrderStatus = {
  pending: "pending",
  confirmed: "confirmed",
  preparing: "preparing",
  out_for_delivery: "out_for_delivery",
  delivered: "delivered",
  cancelled: "cancelled",
  rejected: "rejected",
  delivery_failed: "delivery_failed"
};
var OrderPaymentMethod = {
  cod: "cod"
};
var OrderSource = {
  app: "app",
  phone: "phone",
  whatsapp: "whatsapp",
  pos: "pos",
  manual: "manual"
};
var OP = {
  upsert: "upsert",
  delete: "delete"
};
var InboxType = {
  shift_start: "shift_start",
  receipt_new: "receipt_new",
  shift_end: "shift_end"
};
var ShiftStatus = {
  open: "open",
  pending: "pending",
  confirmed: "confirmed"
};
var ProductType = {
  STANDARD_PRODUCT: "STANDARD_PRODUCT",
  LOCAL_PRODUCT: "LOCAL_PRODUCT",
  WEIGHT_PRODUCT: "WEIGHT_PRODUCT",
  WEIGHT_DEFINED_PRODUCT: "WEIGHT_DEFINED_PRODUCT"
};
var CustomerReturnStatus = {
  active: "active",
  cancelled: "cancelled"
};
var Status = {
  active: "active",
  inactive: "inactive"
};
var Role = {
  owner: "owner",
  employee: "employee"
};
var PaymentMethod = {
  cash: "cash",
  card: "card",
  wallet: "wallet"
};
var CustomerTransactionType = {
  PAYMENT: "PAYMENT",
  ORDER_DEBT: "ORDER_DEBT",
  REFUND: "REFUND",
  ADJUSTMENT: "ADJUSTMENT"
};
export {
  BalanceTransactionType,
  BalanceType,
  CustomerReturnStatus,
  CustomerStatus,
  CustomerTransactionType,
  EmployeeRole,
  ExpenseCategoryOld,
  ImageEntity,
  InboxType,
  LogAction,
  LogStatus,
  MovementType,
  NotificationAudience,
  NotificationStatus,
  OP,
  OrderPaymentMethod,
  OrderSource,
  OrderStatus,
  PaymentMethod,
  Platform,
  ProductType,
  Role,
  ShiftStatus,
  Status,
  StoragePlaceTransferStatus,
  TransactionStatus,
  TransactionType,
  announcementEntity
};
